"use strict";Object.defineProperty(exports, "__esModule", {value: true});/* Saves text as a file through a temporary link. */
 const downloadText = (fileName, text, type) => {
  const url = URL.createObjectURL(new Blob([text], { type }))
  const link = document.createElement('a')
  link.href = url
  link.download = fileName
  document.body.appendChild(link)
  link.click()
  link.remove()
  URL.revokeObjectURL(url)
}; exports.downloadText = downloadText
